<template>
    <div class="download-page">
        <div class="download-step">
            <div class="step-left">
                <div class="step-title">
                    <img src="../assets/images/img_01@2x.png"/>
                    <span>维保无需费心</span>
                </div>
                <p class="txt">掌上车间、保养提醒</p>
                <p class="txt">保养手册、维修保养在线预约</p>
            </div>
            <div><img class="step-img" src="../assets/images/a1.png"/></div>
        </div>
        <div class="download-step">
            <div><img class="step-img" src="../assets/images/a2@2x.png"/></div>
            <div>
                <div class="step-title">
                    <img src="../assets/images/img_02@2x.png"/>
                    <span>爱车说明书</span>
                </div>
                <p class="txt">车辆手册、指示灯</p>
                <p class="txt">让您随时了解您的爱车</p>
            </div>
        </div>
        <div class="download-step">
            <div class="step-left">
                <div class="step-title">
                    <img src="../assets/images/img_03@2x.png"/>
                    <span>U·CLUB<br>官方车主俱乐部</span>
                </div>
                <p class="txt">雪佛兰车主聚集地</p>
                <p class="txt">一键入会后会员礼遇、会员积分、优惠享不停</p>
            </div>
            <div><img class="step-img" src="../assets/images/a3.png"/></div>
        </div>
        <div class="download-step">
            <div><img class="step-img" src="../assets/images/a4.png"/></div>
            <div>
                <div class="step-title">
                    <img src="../assets/images/img_04@2x.png"/>
                    <span>融合超多功能</span>
                </div>
                <p class="txt">行车记录仪、违章查询</p>
                <p class="txt">油耗记录、车主秀、出行助手</p>
                <p class="txt">做您的贴心行车助手</p>
            </div>
        </div>
        <div class="footer" @click="DownLoad">立即打开MyChevy
        </div>
        <div v-if="wallStatus" class="wall-page"></div>
    </div>

</template>
<script>
    import { getAppInfo } from "@/axios/index.js"
    export default {
        name:"AppDownload",
        data(){
            return{
                isWX: true,
                isIOS: false,
                wallStatus: false,
                inforDetail: this.$route.query.inforDetail || "",
                apkUrl: ""
            }
        },
        mounted(){
            //判断设备对象是微信还是iphone
            var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                this.isWX = true
                this.wallStatus = true;
            } else {
                this.isWX = false
                this.wallStatus = false;
            }
            if (/iphone|ipad|ipod/.test(ua)) {
                this.isIOS = true
            } else {
                this.isIOS = false
            }
        },
        methods:{
            // 点击下载，本地安装app跳转到app否则下载app
            DownLoad(){
                if (this.isIOS) {
                    if(this.inforDetail){
                        window.location.href = 'mychevy://mychevy?inforDetail=' + this.inforDetail;
                    }else{
                        window.location.href = 'mychevy://mychevy';
                    }
                    var timeout, t = 1000, hasApp = true;  
                    setTimeout(() => {  
                        if (!hasApp) {
                            // 跳转下载链接
                            this.$router.push({'path':"/Download"})
                        }
                    }, 2000)      
                    var t1 = Date.now();  
                    // 使用a标签方法或iframe方法触发URL Scheme
                    setTimeout(() => {  
                        var t2 = Date.now();  
                        if (t2 - t1 < t + 100) {  
                            hasApp = false;
                        }
                    }, t);
                } else {
                    //android
                    if(this.inforDetail){
                        window.location.href = 'mychevy://mychevy?inforDetail=' + this.inforDetail;
                    }else{
                        window.location.href = 'mychevy://mychevy';
                    }
                    this.downLoadAPK().then(res=>{
                        setTimeout(() => {
                            let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                            if (typeof hidden == "undefined" || hidden == false) {
                                //应用宝下载地址
                                window.location.href = this.apkUrl;
                            }
                        }, 3000);
                    })
                }
            },
            downLoadAPK () {
                return new Promise((resolve, reject) => {
                    getAppInfo().then(res => {
                        if (res.errcode == 0) {
                            this.apkUrl = res.data.download_url
                            resolve()
                        }
                    })
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    .download-page {
        min-height: 100vh;
        background: url(../assets/images/bg@2x.png) no-repeat #f5f5f5 top center;
        background-size: 100% 697px;
        padding: 193px 10px 50px 10px;
        .download-step {
            background: #FFFFFF;
            border-radius: 8px;
            height: 200px;
            display: flex;
            align-items: center;
            justify-content: right;
            margin-bottom: 10px;
            .step-left {
                margin-left: 16px;
            }
            .txt {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                text-align: justify;
                line-height: 26px;
                margin-left: 6px;
            }
            .step-title {
                margin-bottom: 24px;
                font-family: PingFangSC-Medium;
                font-size: 18px;
                color: #333333; 
                display: flex;
                align-items: center;
                img {
                    width: 32px;
                    height: 32px;
                    margin-right: 10px;
                }
            }
            .step-img {
                width: 148px;
            }
        }
        .footer {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 1;
            height: 45px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #333;
            font-size: 16px;
            font-family: PingFangSC-Regular;
            background-image: linear-gradient(179deg, #FFD444 2%, #FFC914 100%);
            .btn {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                width: 120px;
                height: 28px;
                border-radius: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .download-btn {
                margin-left: 51px;
            }
        }
        .wall-page {
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 10;
            background: url(../assets/images/browser.png) no-repeat right top rgba(0, 0, 0, 0.8);
            background-size: 375px 180px;

        }
    }
</style>